import { ApiDocumentProcessModel } from "./api-document-process.model";

export class VerifyResponse {
    isVerified: boolean;
    verifyDocumentGrid: ApiDocumentProcessModel[];
}